/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_FundInputs */

const en_common_fund = /** @type {(inputs: Common_FundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fund`)
};

/**
* | output |
* | --- |
* | "Fund" |
*
* @param {Common_FundInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_fund = /** @type {((inputs?: Common_FundInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_FundInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_fund(inputs)
});